import './ModalContentCreate.scss'
import ModalContentCreate from './ModalContentCreate'

export default ModalContentCreate
